<template>
  <div class="user-manage-container">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-button v-if="hasAddPermission" type="primary" class="add-btn" @click="addDialogVisible = true">添加</el-button>

      <!-- 引入添加用户组件 -->
      <AddUserDialog :visible="addDialogVisible" @update:visible="addDialogVisible = $event"
        @submit="handleAddSubmit" />

      <!-- 引入编辑用户组件 -->
      <EditUserDialog :visible="editDialogVisible" @update:visible="editDialogVisible = $event"
        :userData="currentEditUser" @submit="handleEditSubmit" />

      <el-form :inline="true" class="search-form">
        <el-form-item>
          <el-input placeholder="用户名称" class="search-input"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="用户电话" class="search-input"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="公司名称" class="search-input"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="用户状态" class="search-select">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="search-btn">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="reset-btn">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-container">
      <el-table :data="userList" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="name" label="用户名称" width="120" align="center"></el-table-column>
        <el-table-column prop="account" label="用户账户" width="120" align="center"></el-table-column>
        <el-table-column prop="phone" label="用户电话" width="150" align="center"></el-table-column>
        <el-table-column prop="company" label="公司名称" width="" align="center">
          <template slot-scope="scope">
            {{ scope.row.company ? scope.row.company.company_name : '无' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="用户状态" width="100" align="center">
          <template slot-scope="scope">
            <span class="status-enabled" v-if="scope.row.status === 1 || scope.row.status === '1'">启用</span>
            <span class="status-disabled" v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180" align="center"></el-table-column>
        <el-table-column label="操作" width="180" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button v-if="hasEditPermission" type="text" class="edit-btn"
              @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button v-if="hasDeletePermission" type="text" class="delete-btn"
              @click="handleDelete(scope.row)">删除</el-button>
            <el-button v-if="hasResetPermission" type="text" class="reset-btn"
              @click="handleResetPassword(scope.row)">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
          :page-size="pagination.pageSize" :current-page="pagination.currentPage" @size-change="handleSizeChange"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AddUserDialog from '@/components/user/AddUserDialog.vue'
import EditUserDialog from '@/components/user/EditUserDialog.vue'
import { userList, userDelete, resetPassword } from '@/api/api'
import { hasPermission } from '@/utils/auth'

export default {
  name: 'UserManage',
  components: {
    AddUserDialog,
    EditUserDialog
  },
  data() {
    return {
      userList: [],
      addDialogVisible: false,
      editDialogVisible: false,
      currentEditUser: {},
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 加载状态
      loading: false,
      form: {
        name: '',
        phone: '',
        status: 1,
        role: '',
        password: ''
      },
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        status: [{ required: true, message: '请选择用户状态', trigger: 'change' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  computed: {
    // 按钮权限检查
    hasAddPermission() {
      return hasPermission('add')
    },
    hasEditPermission() {
      return hasPermission('edit')
    },
    hasDeletePermission() {
      return hasPermission('delete')
    },
    hasResetPermission() {
      return hasPermission('reset')
    }
  },
  created() {
    // 组件创建时获取用户列表
    this.fetchUserList();
  },
  methods: {
    // 获取用户列表
    fetchUserList() {
      this.loading = true;
      const params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize
      };
      userList(params)
        .then(response => {
          if (response && response.code === 200) {
            this.userList = response.data.list || [];
            this.pagination.total = response.data.total || 0;
          } else {
            this.$message.error('获取用户列表失败');
            this.userList = [];
            this.pagination.total = 0;
          }
        })
        .catch(error => {
          console.error('获取用户列表失败:', error);
          this.$message.error('获取用户列表异常，请重试');
          this.userList = [];
          this.pagination.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页变化处理
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchUserList();
    },
    handleCurrentChange(current) {
      this.pagination.currentPage = current;
      this.fetchUserList();
    },
    // 处理添加用户提交
    handleAddSubmit(formData) {
      // 这里可提交表单数据
      console.log('添加用户:', formData);
      // 添加成功后重新获取用户列表
      this.fetchUserList();
    },
    // 打开编辑弹框
    openEditDialog(row) {
      this.currentEditUser = row;
      this.editDialogVisible = true;
    },
    // 处理编辑用户提交
    handleEditSubmit(formData) {
      // 这里可提交编辑数据
      console.log('编辑用户:', formData);
      // 编辑成功后重新获取用户列表
      this.fetchUserList();
    },
    // 处理删除用户
    handleDelete(row) {
      this.$confirm('确定要删除该用户吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用userDelete接口删除用户
        const params = {
          id: row.id
        };
        console.log('调用userDelete接口，参数:', params);
        userDelete(params)
          .then(response => {
            console.log('userDelete接口响应:', response);
            if (response && response.code === 200) {
              this.$message.success('删除成功');
              // 删除成功后重新获取用户列表
              this.fetchUserList();
            } else {
              this.$message.error(response.message);
            }
          })
          .catch(error => {
            console.error('删除用户异常:', error);
            this.$message.error(error.message);
          });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    // 处理重置密码
    handleResetPassword(row) {
      this.$confirm('确定要重置该用户的密码吗？', '重置密码确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用resetPassword接口重置密码
        const params = {
          id: row.id
        };
        console.log('调用resetPassword接口，参数:', params);
        resetPassword(params)
          .then(response => {
            console.log('resetPassword接口响应:', response);
            if (response && response.code === 200) {
              this.$message.success('重置密码成功');
            } else {
              this.$message.error(response.message);
            }
          })
          .catch(error => {
            console.error('重置密码异常:', error);
            this.$message.error(error.message);
          });
      }).catch(() => {
        this.$message.info('已取消重置密码');
      });
    }
  }
}
</script>

<style scoped lang="scss">
.user-manage-container {
  padding: 20px;
  background-color: #fff;
  height: 100%;
}

.search-bar {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;

}

.search-form {
  ::v-deep .el-form-item {
    margin-bottom: 0 !important;
  }
}

.add-btn {
  background-color: #1890ff;
  border-color: #1890ff;
}

.search-form {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-input {
  width: 180px;
}

.search-select {
  width: 150px;
}

.search-btn {
  background-color: #1890ff;
  border-color: #1890ff;
}

.reset-btn {
  color: #666 !important;
}

.table-container {
  width: 100%;
}

/* 表格头部样式 */
::v-deep .el-table th {
  background-color: rgb(245, 247, 250) !important;
  color: #333;
  font-weight: bold;
}

/* 表格行样式 */
::v-deep .el-table tr {
  height: 48px;
}

.status-enabled {
  color: #1890ff;
}

.status-disabled {
  color: #999;
}

.edit-btn {
  color: #1890ff;
  margin-right: 10px;
}

.delete-btn {
  color: #ff4d4f;
  margin-right: 10px;
}

.reset-btn {
  color: #1890ff;
}
</style>